"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
const testimonials = [{
  id: 1,
  quote: "SimProTiling transformed our master bathroom into a high-end wet room. The precision of the large format porcelain tiles and the mitred edges are simply flawless.",
  author: "Marcus V.",
  location: "Chelsea, SW3",
  rating: 5
}, {
  id: 2,
  quote: "Incredible attention to detail. The epoxy grout finish is perfect, and the team handled the self-levelling and Ditra matting installation with total professionalism.",
  author: "Sarah J.",
  location: "Fulham, SW6",
  rating: 5
}, {
  id: 3,
  quote: "The most professional tilers we've worked with in London. Our walk-in shower is a work of art, with perfectly aligned patterns and a seamless waterproof finish.",
  author: "Julian P.",
  location: "Hampstead, NW3",
  rating: 5
}, {
  id: 4,
  quote: "Outstanding craftsmanship on our renovation. They delivered a luxury finish that exceeded our expectations. Highly recommend for any high-end tiling project.",
  author: "Claire W.",
  location: "Kensington, W8",
  rating: 5
}];
export default function ClientSuccessStories() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const handlePrev = () => {
    api?.scrollPrev();
  };
  const handleNext = () => {
    api?.scrollNext();
  };
  return <section data-section-id="36529" id="client-success-stories" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="container ml-0 mr-auto px-6 md:px-12 max-w-5xl">
        <div className="text-left mb-16">
          <h2 className="text-sm font-bold tracking-widest text-black uppercase mb-3">
            Testimonials
          </h2>
          <h3 className="font-serif text-3xl md:text-5xl text-black tracking-tight">
            Client Success Stories
          </h3>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={item.id} data-index={i} className="basis-full">
                <div className="flex flex-col items-start text-left max-w-3xl ml-0 px-4">
                  <div className="font-serif text-[120px] leading-none h-24 overflow-visible select-none mb-6" style={{
                color: "black"
              }} aria-hidden="true">
                    &ldquo;
                  </div>

                  <blockquote className="font-serif italic text-[24px] md:text-[28px] leading-relaxed text-black mb-10">
                    {item.quote}
                  </blockquote>

                  <div className="flex gap-1 mb-6">
                    {Array.from({
                  length: item.rating
                }).map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-black text-black" />)}
                  </div>

                  <div className="flex flex-col items-start gap-1">
                    <cite className="not-italic font-bold text-lg text-black font-sans">
                      {item.author}
                    </cite>
                    <span className="text-black text-xs uppercase tracking-widest font-sans">
                      {item.location}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        <div className="flex items-center justify-start gap-8 mt-16">
          <Button variant="link" onClick={handlePrev} className="text-black hover:text-black/70 font-bold text-base no-underline hover:no-underline p-0 h-auto transition-colors duration-300 uppercase tracking-widest">
            Previous
          </Button>
          <span className="text-black/30">|</span>
          <Button variant="link" onClick={handleNext} className="text-black hover:text-black/70 font-bold text-base no-underline hover:no-underline p-0 h-auto transition-colors duration-300 uppercase tracking-widest">
            Next
          </Button>
        </div>
      </div>
    </section>;
}